import { render } from "./WizardChat.vue?vue&type=template&id=32ea3f58&scoped=true&ts=true"
import script from "./WizardChat.vue?vue&type=script&lang=ts"
export * from "./WizardChat.vue?vue&type=script&lang=ts"

import "./WizardChat.vue?vue&type=style&index=0&id=32ea3f58&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ea3f58"]])

export default __exports__